import styled from 'styled-components'

import { Text } from '@interco/inter-ui/components/Text'

export const ArticleLink = styled(Text)`
  display: inline-block;
  color: var(--button-link-text-color);
  font-weight: 700;
`
